class BESSAppProjectsMap extends BESSAppComponent {

    constructor() {
        super('.projects-map');
    }

    setupComponent(componentNode) {
        BESSApp.instance.requireGoogleMaps(function () {
            let withControls = componentNode.hasClass('with-controls');
            let map = BESSSetupMapComponent(componentNode, null, 12, withControls, withControls, 'BESS');
            let bounds = new google.maps.LatLngBounds();

            const markers = projectsMapLocations.map((position, i) => {
                //const label = labels[i % labels.length];
                const pinGlyph = new google.maps.marker.PinElement({
                    glyph: "",
                    glyphColor: "white",
                });
                const location = new google.maps.LatLng(position[0], position[1]);
                bounds.extend(location);
                const marker = new google.maps.marker.AdvancedMarkerElement({
                    position: location,
                    content: pinGlyph.element,
                });
                return marker;
            });
            new markerClusterer.MarkerClusterer({markers, map});
            map.fitBounds(bounds);

        });
    }
}
